__turbopack_context__.v({
  "card": "Card-module__r9_ZKW__card",
  "elevated": "Card-module__r9_ZKW__elevated",
  "lead": "Card-module__r9_ZKW__lead",
});
